module.exports = __webpack_public_path__ + "img/logo.cd34a0b.svg";